"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userRepositoryMethods = void 0;
const repository_types_1 = require("./repository.types");
exports.userRepositoryMethods = (0, repository_types_1.generateRepositoryMethods)({
    integrateInsuranceUser: {
        callMethod: 'POST',
        endpoint: '/user/integrate-insurance',
    },
    getOauthAuthorizationUrl: {
        callMethod: 'GET',
        endpoint: '/user/authorization-url',
    },
    linkInsuranceUserWithOAuthCode: {
        callMethod: 'POST',
        endpoint: '/user/oauth/link-insurance',
    },
    linkInsuranceUser: {
        callMethod: 'POST',
        endpoint: '/user/link-insurance',
    },
    getAccountMetaInformation: {
        callMethod: 'GET',
        endpoint: '/user/account/meta-information',
    },
    createInsuranceMapping: {
        callMethod: 'POST',
        endpoint: '/user/create-insurance-mapping',
    },
});
//# sourceMappingURL=user.methods.js.map